import { render, staticRenderFns } from "./load.vue?vue&type=template&id=12f66c44&scoped=true&"
import script from "./load.vue?vue&type=script&lang=js&"
export * from "./load.vue?vue&type=script&lang=js&"
import style0 from "./load.vue?vue&type=style&index=0&id=12f66c44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f66c44",
  null
  
)

export default component.exports